import { Box } from "@mui/material";

const InputWrapper = ({
  padding,
  children,
  width,
}: {
  padding: string | number;
  children: any;
  width: number | string;
}) => {
  return (
    <Box border="1px solid #6E8C20" p={padding} borderRadius={2} width={width}>
      {children}
    </Box>
  );
};

export default InputWrapper;
